
  const my_Shop_Currency = "£";
  // function upsellCartResizing(){
  //   if($('.cart-upsell').is(':visible') ){
  //     let upsellHeight = $('.cart-upsell').outerHeight();
  //     $('.cart-item-wrap').css("height", 'calc(100% - '+upsellHeight+'px)');
  //   } else {
  //     $('.cart-item-wrap').css("height", '100%');
  //   }
  // }
  // upsellCartResizing();
  $(".addToCart").on("click", function (e) {
    e.preventDefault(), $(this).addClass("loading");
    //console.log("clicked");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $(this).parent().parent().serialize(),
      dataType: "json",
      success: function (data) {
        get_cart_details();
        $("body").addClass("cartShown");

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: $('.pump-form').serialize(),
          dataType: "json",
          success: function (data) {
            get_cart_details();
          },
          error: function (err) {
            console.log("error", err);
          },
        });
      },
      error: function (err) {
        console.log("error", err);
      },
    });

    
  });

  // upsell
  $(".upsell-btn").on("click", function (e) {
    e.preventDefault(), console.log("clicked");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $(this).parent().serialize(),
      dataType: "json",
      success: function (data) {
        get_cart_details();
        $("body").addClass("cartShown");
        $(".upsell_product").hide();
      },
      error: function (err) {
        console.log("error");
      },
    });
  });

  //  sticky atc
  $(".sticky-atc").on("click", function (e) {
    e.preventDefault(),
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: $(".sticky-form").serialize(),
        dataType: "json",
        success: function (data) {
          get_cart_details();
          $("body").addClass("cartShown");
        },
        error: function (err) {
          console.log("error");
        },
      });
  });

  
  // $(document).on("click",".the-cart-upsell__btn",function(e) {
  //   e.preventDefault(),
  //     $.ajax({
  //       type: "POST",
  //       url: "/cart/add.js",
  //       data: $(".upsell-form").serialize(),
  //       dataType: "json",
  //       success: function (data) {
  //         get_cart_details();
  //       },
  //       error: function (err) {
  //         console.log("error");
  //       },
  //     });
  // });

  function addUpsell(e, el){
    e.preventDefault(),
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $(".upsell-form").serialize(),
      dataType: "json",
      success: function (data) {
        get_cart_details();
      },
      error: function (err) {
        console.log("error");
      },
    });
  }



  // cart details
  function cartHeightCheck() {
    var cartTopHeight = $(".cart-wrap .cart-top").outerHeight();
    //   var cartBottomHeight = $('.cart-bottom').outerHeight();
    windowHeight = $(window).outerHeight();
    windowNeedHeight = windowHeight - cartTopHeight;
    bottomPadding = $(".cart-wrap .cart-bottom").outerHeight();
    $(".cart-wrap .cart-main").css({
      height: windowNeedHeight,
      "padding-bottom": bottomPadding,
    });
  }


  function get_cart_details() {
    $('.addToCart').removeClass('loading');
   fetch("?section_id=cart-drawer")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        // var cart = $('.main-cart-wrap',cart_html);
        var cart_items = $(".cart-main", cart_html);
        var show_check = $(".checkbox-wrap", cart_html);
        var shipping_progress = $(".cart-top", cart_html);
        var cartBottom = $(".cart-bottom", cart_html);
        // $(".main-cart-wrap").replaceWith(cart);
        $(".cart-main").replaceWith(cart_items);
        $(".checkbox-wrap").replaceWith(show_check);
        $(".cart-top").replaceWith(shipping_progress);
        $(".cart-bottom").replaceWith(cartBottom);
      });

      fetch("?section_id=header")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        var cart_count = $(".cart-count span", cart_html);
        $(".cart-count span").replaceWith(cart_count);
      });
      // cartHeightCheck();

      // fetch("?section_id=product")
      // .then((response) => response.text())
      // .then((productData) => {
      //   var product_html = $(productData);
      //   var pump_product = $(".add-pump-wrap", product_html);
      //   $(".add-pump-wrap").replaceWith(pump_product);
      // });

      $.getJSON('/cart.js', function(cart) {
        var cart_items = cart.items;
        for(var i=0; i<=cart_items.length; i++){
          var product_id = cart_items[i].variant_id;
          if(product_id == '41903165702316'){
            console.log('Pump found');
            updatePump();
          }
          console.log(product_id);
        }
      });
  }

// $(window).on('resize', function(){
//   upsellCartResizing();
// });
 // increase item
 function increaseItem(e, el) {
  var myElement = el;
  $input = myElement.previousElementSibling;
  var value = parseInt($input.value);
  if (value < 100) {
    value = value + 1;
  } else {
    value = 100;
  }
  $input.value = value;
  changeQty($input);

};

// decrease item
function decreaseItem(e, el) {
  $input = el.nextElementSibling;
  var value = parseInt($input.value);
  if (value > 1) {
    value = value - 1;
  } else {
    value = 1;
  }
  $input.value = value;
  changeQty($input);
};

function changeQty($input){
  var variant_id= $($input).attr("data-id");
  var quantity= $($input).val();          
  var data = { updates: {} };
  data.updates[variant_id] = quantity;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {               
      get_cart_details();
    }
  });
};


// Remove
function itemRemove(e, el) {
e.preventDefault();
var variant_id = $(el).attr('data-id');
console.log(variant_id);
var data = {
  updates: {}
};
data.updates[variant_id] = '0';
jQuery.ajax({
  type: 'POST',
  url: '/cart/update.js',
  data: data,
  dataType: 'json',
  success: function(res) {
    get_cart_details();
    $.getJSON('/cart.js', function(cart) {
      var product_total_price = cart.items_subtotal_price;
      console.log(product_total_price);
      if(product_total_price <= 0){
        removePump();
      }
    });  
  }
});

// $(el).parent().parent().remove();
}



// Remove free pump
function removePump() {
  var variant_id = '41903165702316';
  console.log(variant_id);
  var data = {
    updates: {}
  };
  data.updates[variant_id] = '0';
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {
      get_cart_details();
    }
  });
  
  
  }

  function updatePump(){
    var variant_id = '41903165702316';
    console.log(variant_id);
    var data = {
      updates: {}
    };
    data.updates[variant_id] = '1';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        fetch("?section_id=header")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        var cart_count = $(".cart-count span", cart_html);
        $(".cart-count span").replaceWith(cart_count);
      });
      }
    });
  }





function closeCart(e, el) {
  $('body').removeClass('cartShown');

};